module.exports = __webpack_public_path__ + "static/media/sashimi.9527036c.png";